// extracted by mini-css-extract-plugin
export default {"dark":"InfosInviteUser_dark__PvKiY","App":"InfosInviteUser_App__nlynU","container":"InfosInviteUser_container__FDdBT"};